import { siteResolver } from '../site-resolver';
import { sparkleUtils } from '@/shared/sparkle-utils';

export type SitePathMapping = {
  region: string;
  website: string;
};

export class SitePathMappingService {
  private static readonly SITE_TO_PATH_MAPPING: Record<string, SitePathMapping> = {
    AdvocateHealthCom: { region: 'Advocate Aurora', website: 'advocate' },
    AdvocateChildrensHospitalCom: { region: 'Advocate Aurora', website: 'advocate' },
    AdvocateHealthOrg: { region: 'Advocate Aurora', website: 'advocate' },
    AuroraBayCareCom: { region: 'Advocate Aurora', website: 'baycare' },
    AuroraHealthCareOrg: { region: 'Advocate Aurora', website: 'aurora' },
    AtriumHealthFloydHarbinOrg: { region: 'Atrium', website: 'atrium' },
    WellnessAdvocateHealthOrg: { region: 'Advocate Aurora', website: 'advocate' },
  };

  //TODO: REFACTOR access to current siteName
  public static MapSitePath(domain: string): SitePathMapping | null {
    if (sparkleUtils.isEmptyOrWhiteSpace(domain)) return null;
    const site = siteResolver.getByHost(domain);
    const result = SitePathMappingService.SITE_TO_PATH_MAPPING[site.name];
    return result;
  }
}
